import { setNewbuildingBrokerCallbackWidgetBookingLoading, toggleNewbuildingBrokerBookingExistsModal } from './actions';
import { getUser } from 'shared/selectors/user';
import { canMakeNewbuildingBrokerRequest } from 'shared/services/canMakeNewbuildingBrokerRequest';
import { TThunkAction } from 'shared/types/redux';

export function checkBookingExists(navigationHandler: () => void): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const user = getUser(getState());

    try {
      dispatch(setNewbuildingBrokerCallbackWidgetBookingLoading(true));

      if (!user?.isAuthenticated) {
        navigationHandler();

        return;
      }

      const canMakeRequest = await canMakeNewbuildingBrokerRequest(context);

      if (canMakeRequest) {
        navigationHandler();
      } else {
        dispatch(toggleNewbuildingBrokerBookingExistsModal(true));
        dispatch(setNewbuildingBrokerCallbackWidgetBookingLoading(false));
      }
    } catch (error) {
      // Страница бронирования проверит на своей стороне.
      navigationHandler();
    }
  };
}
